<template>
  <section class="match-signup-entry-section">
    <div class="signup-entry-mobile-buttons">
      <div
        v-for="button in entryData.entryButtons"
        :key="`${button.id}-mobile`"
        class="signup-entry-mobile-button"
        @click="handleClick(button)"
      >
        <img :src="button.mobileImage || button.image" alt="报名入口" />
      </div>
    </div>

    <div class="signup-entry-buttons">
      <div
        v-for="button in entryData.entryButtons"
        :key="button.id"
        class="signup-entry-button"
        @click="handleClick(button)"
      >
        <img class="signup-entry-button-image" :src="button.image" alt="报名入口" />
        <img class="signup-entry-button-hover-image" :src="button.hoverImage" alt="报名入口" />
      </div>
    </div>

    <img ref="watchTitle" class="signup-watch-title" :src="entryData.watchTitleImage" alt="观赛地址" />
    <img ref="mobileWatchTitle" class="signup-watch-title-mobile" :src="entryData.mobileWatchTitleImage || entryData.watchTitleImage" alt="观赛地址" />

    <div class="signup-info-cards">
      <img v-for="(card, index) in entryData.cards" :key="index" :src="card" alt="赛事信息" />
    </div>

    <div class="signup-info-cards-mobile">
      <img v-for="(card, index) in entryData.mobileCards || entryData.cards" :key="`mobile-${index}`" :src="card" alt="赛事信息" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatchSignupEntrySection',
  props: {
    entryData: { type: Object, required: true },
  },
  methods: {
    handleClick(button) {
      if (button.route) {
        this.$router.push({
          path: button.route,
          query: button.anchor ? { anchor: button.anchor } : {},
        })
        return
      }
      if (button.link) this.$router.push(button.link)
    },
    scrollToWatchTitle() {
      const target = window.innerWidth <= 750
        ? this.$refs.mobileWatchTitle
        : this.$refs.watchTitle

      if (!target) return
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.match-signup-entry-section {
  height: 10.71875rem;
  margin: 0 auto;
  padding-top: 3.973958rem;
  box-sizing: border-box;

  .signup-entry-mobile-buttons,
  .signup-watch-title-mobile,
  .signup-info-cards-mobile {
    display: none;
  }

  .signup-entry-buttons {
    display: flex;
    justify-content: center;
    gap: 0.208333rem;
  }

  .signup-entry-button {
    position: relative;
    width: 1.609375rem;
    height: 0.463542rem;
    cursor: pointer;

    img {
      display: block;
      width: 1.609375rem;
      height: 0.463542rem;
    }

    .signup-entry-button-hover-image {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &:hover {
      .signup-entry-button-hover-image {
        opacity: 1;
      }
    }
  }

  .signup-watch-title {
    display: block;
    width: 5.729167rem;
    height: 1.114583rem;
    margin: 1.145833rem auto 0.3125rem;
  }

  .signup-info-cards {
    display: flex;
    justify-content: center;
    gap: 0.276042rem;

    img {
      display: block;
      width: 2.223958rem;
      height: 3.723958rem;
    }
  }
}

@media (max-width: 750px) {
  .match-signup-entry-section {
    height: auto;
    box-sizing: border-box;
    padding: 14.853333rem 0 0.145rem;

    .signup-entry-mobile-buttons {
      display: flex;
      justify-content: center;
      gap: 0.453333rem;
      width: 10rem;

      .signup-entry-mobile-button {
        width: 3.413333rem;
        height: 0.986667rem;
        cursor: pointer;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }

    .signup-entry-buttons,
    .signup-watch-title,
    .signup-info-cards {
      display: none;
    }

    .signup-watch-title-mobile {
      display: block;
      width: 9.333333rem;
      height: 1.813333rem;
      margin: 1.386667rem auto 0.746667rem;
    }

    .signup-info-cards-mobile {
      display: flex;
      justify-content: space-between;
      width: 10rem;
      margin: 0;
      padding: 0 0.266667rem;
      box-sizing: border-box;

      img {
        display: block;
        width: 2.90312rem;
        height: 4.872187rem;
      }
    }
  }
}

</style>
